import {
  Ability
} from '@casl/ability';
import * as types from "../mutation-types";

export const ability = new Ability();

export const abilityPlugin = (store) => {
  ability.update(store.state.rules);

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case "uiPermissions/" + types.LOAD_RULES:
        ability.update(mutation.payload.rules);
        break;
      case "uiPermissions/" + types.DESTROY_RULES:
        ability.update([]);
        break;
    }
  });
};
